import React, { useEffect } from 'react';
import RoleBasedRoute from './RoleBasedRoute';

/**
 * Protected route specifically for Podcast users
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child components to render if authenticated
 * @returns {React.ReactNode} - The protected component or redirect
 */
const PodcastRoute = ({ children }) => {
  useEffect(() => {
    console.log("PodcastRoute: Checking authentication");
    console.log("Token:", localStorage.getItem('token'));
    console.log("UserRole:", localStorage.getItem('userRole'));
    console.log("UserData:", localStorage.getItem('userData'));
  }, []);

  return (
    <RoleBasedRoute 
      allowedRoles="podcastuser" 
      redirectPath="/podcast/login"
    >
      {children}
    </RoleBasedRoute>
  );
};

export default PodcastRoute;
